module.exports = __webpack_public_path__ + "static/media/boat-img-14.c1a6ae8d.jpg";